var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('HomeImg'),_vm._v(" "),_c('introduction'),_vm._v(" "),_c('cpjs'),_vm._v(" "),_c('jjfa'),_vm._v(" "),_c('llyy'),_vm._v(" "),_c('gsxw')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8983092","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/en/HelloWorld.vue
// module id = null
// module chunks = 